(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  // Secure independent scroll and sticky listener.
  // This bypasses the Custom Elements duplicate definition crash in standard Shopify theme packages.
  document.addEventListener('DOMContentLoaded', () => {
    const initStickyHeader = () => {
      const headerWrapper = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
      if (!headerWrapper) return;

      const headerSection = headerWrapper.closest('.shopify-section') || headerWrapper.closest('.section-header') || document.getElementById('shopify-section-header');
      if (!headerSection) return;

      const stickyType = headerWrapper.getAttribute('data-sticky-type') || 'always';
      const isAlwaysSticky = stickyType === 'always' || stickyType === 'reduce-logo-size';

      // Safe header measurement
      const setHeight = () => {
        document.documentElement.style.setProperty('--header-height', `${headerSection.offsetHeight}px`);
      };
      setHeight();
      window.addEventListener('resize', setHeight);

      // Traverses ancestral hierarchy, auto-healing native overflow scroll-containment blocks
      let parent = headerSection.parentElement;
      while (parent) {
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'hidden' || style.overflowX === 'hidden' || style.overflowY === 'hidden') {
          if (parent === document.documentElement || parent === document.body) {
            parent.style.setProperty('overflow-x', 'clip', 'important'); // blocks overflow scrolling without breaking sticky layouts
          } else {
            parent.style.setProperty('overflow', 'visible', 'important');
            parent.style.setProperty('overflow-x', 'visible', 'important');
            parent.style.setProperty('overflow-y', 'visible', 'important');
          }
        }
        parent = parent.parentElement;
      }

      if (isAlwaysSticky) {
        headerSection.classList.add('shopify-section-header-sticky');
      }

      let lastScrollTop = 0;
      let isScrollingTimeout;

      const handleScroll = () => {
        // Safe check: do not apply sticky translations if a cart drawer is actively overlayed
        if (document.body.classList.contains('overflow-hidden') || document.body.classList.contains('cart-drawer-active')) {
          return;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const headerHeight = headerSection.offsetHeight || 120;

        if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
          // Scrolling Down
          headerSection.classList.add('scrolled-past-header');
          if (!isAlwaysSticky) {
            headerSection.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
          }
        } else if (scrollTop < lastScrollTop && scrollTop > headerHeight) {
          // Scrolling Up
          headerSection.classList.add('scrolled-past-header');
          if (!isAlwaysSticky) {
            headerSection.classList.add('shopify-section-header-sticky', 'animate');
            headerSection.classList.remove('shopify-section-header-hidden');
          }
        } else if (scrollTop <= headerHeight) {
          // At Top
          headerSection.classList.remove('scrolled-past-header');
          if (!isAlwaysSticky) {
            headerSection.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
          }
        }
        lastScrollTop = scrollTop;
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll(); // Call once on initialize
    };

    // Run safe sticky header registration
    initStickyHeader();

    // Dynamic Hover interaction handler (supports dropdowns, submenus and mega-menus)
    const initHoverMenus = () => {
      if (window.innerWidth >= 990) {
        const detailsElements = document.querySelectorAll(
          '.header__inline-menu details, header-mega-menu details, details-disclosure details, .mega-menu__list details'
        );
        
        detailsElements.forEach((details) => {
          let closeTimer;
          
          const openMenu = () => {
            clearTimeout(closeTimer);
            details.setAttribute('open', '');
            const summary = details.querySelector('summary');
            if (summary) {
              summary.setAttribute('aria-expanded', 'true');
            }
          };
          
          const closeMenu = () => {
            closeTimer = setTimeout(() => {
              details.removeAttribute('open');
              const summary = details.querySelector('summary');
              if (summary) {
                summary.setAttribute('aria-expanded', 'false');
              }
            }, 150); // Fluid timing buffer
          };

          // Mouse activity binding
          details.addEventListener('mouseenter', openMenu);
          details.addEventListener('mouseleave', closeMenu);
          
          // Tab focus binding
          details.addEventListener('focusin', openMenu);
          details.addEventListener('focusout', (e) => {
            if (!details.contains(e.relatedTarget)) {
              closeMenu();
            }
          });

          // Prevent clicking headings to loop/toggle states on desktop layout
          const summary = details.querySelector('summary');
          if (summary) {
            summary.addEventListener('click', (e) => {
              if (window.innerWidth >= 990) {
                e.preventDefault();
                e.stopPropagation();
                
                const link = summary.querySelector('a');
                if (link && link.getAttribute('href')) {
                  window.location.href = link.getAttribute('href');
                }
              }
            });
          }
        });
      }
    };

    // Run layout configurations
    initHoverMenus();
    window.addEventListener('resize', initHoverMenus);

    // Dynamic label processor logic (matches format "[HOT]", "[NEW]")
    const initMenuBadges = () => {
      // Expanded selector list to scan both top-level and grandchild/submenu links
      const menuItems = document.querySelectorAll(
        '.header__menu-item, .list-menu__item, .menu-drawer__menu-item, .header__inline-menu details summary, .header__submenu a, .mega-menu__link, .mega-menu__list a'
      );
      
      const badgeRegex = /\[(HOT|NEW|SALE|TRENDING)\]/i;

      menuItems.forEach((item) => {
        if (item.classList.contains('badge-processed')) return;

        const treeWalker = document.createTreeWalker(item, NodeFilter.SHOW_TEXT, null, false);
        let textNode;
        let matchedNode = null;

        while (textNode = treeWalker.nextNode()) {
          if (badgeRegex.test(textNode.nodeValue)) {
            matchedNode = textNode;
            break;
          }
        }

        if (matchedNode) {
          const match = matchedNode.nodeValue.match(badgeRegex);
          const badgeText = match[1].toUpperCase();

          matchedNode.nodeValue = matchedNode.nodeValue.replace(badgeRegex, '').trim();

          const badge = document.createElement('span');
          badge.className = `menu-badge badge-${badgeText.toLowerCase()}`;
          badge.textContent = badgeText;

          item.appendChild(badge);
        }

        item.classList.add('badge-processed');
      });
    };

    initMenuBadges();
  });

  } catch(e) { console.error(e); }
})();
})();
